import { useCallback, useMemo, useState } from 'react';

import { contactGroupService } from 'contacts/services';
import { IContactGroup } from 'contacts/types';
import { TableLayoutType } from 'core/enums';
import { AgGridServerTableProvider } from 'core/states';
import { AgGridGetRowsParams } from 'core/types';
import { removeNullValuesNestedObject } from 'core/utils';

import { columnDef } from './columns';
import { VendorContactGroupListTable } from './VendorContactGroupListTable';

export const VendorContactGroupList = () => {
  const [selectedContactGroup, setSelectedContactGroup] = useState<IContactGroup | null>(null);

  const openDetails = useCallback((data: IContactGroup) => setSelectedContactGroup(data), []);

  const defaultColDef = useMemo(() => ({ autoHeight: true }), []);

  const columnDefs = useMemo(() => columnDef(openDetails), [openDetails]);

  const getRows = useCallback(({ filters, ...rest }: AgGridGetRowsParams) => {
    return contactGroupService.getContactGroups(
      removeNullValuesNestedObject({
        filters: {
          isVendor: '"1"',
          ...filters,
        },
        ...rest,
      })
    );
  }, []);

  return (
    <AgGridServerTableProvider
      tableId="vendorContactGroupListTable"
      entityType="ContactGroup"
      columnDefs={columnDefs}
      defaultColDef={defaultColDef}
      getRows={getRows}
      layoutType={TableLayoutType.VENDOR_CONTACT_GROUP}
      hasLayoutActions
      hasManageFilters
    >
      <VendorContactGroupListTable
        selectedContactGroup={selectedContactGroup}
        setSelectedContactGroup={setSelectedContactGroup}
      />
    </AgGridServerTableProvider>
  );
};
